export default __webpack_public_path__ + "static/media/about.6323c8f3.svg";